import Vue from 'vue';
import { provideVariables } from './index';

window.bus = new Vue();

export default provideVariables('$bus', window.bus);
